import React from 'react';
import { getDomain } from '@web/tools/getDomain';
import { useUser } from '@sde/widgets-core/src/redux/resources/user';
import { useProvider } from '@src/state/provider';
import { useDashboard } from '@src/state/dashboard';

export const TrackItFlyout = () => {
  const { user } = useUser.state();
  const { provider } = useProvider.state();
  const { trackItFlyout } = useDashboard.state();
  const domain = getDomain('sde-trackit', 3400);
  return (
    <abyss-parcel
      user={JSON.stringify(user)}
      provider={JSON.stringify(provider)}
      scriptdomain={domain}
      import='trackit-flyout@dev'
      trackitflyout={JSON.stringify(trackItFlyout)}
    />
  );
};
